import { ContentService } from '@blk/cwp-ng-framework';
import { InjectConfig, TaxConfigKey } from '@ddt-web/config-layer';
import * as isNil from 'lodash/isNil';

import { CellUtil } from '../../utils/cell-util';
import { CellData } from '../cell-data';
import { ColumnConfig } from '../column-config';
import { TableData } from '../table-data';
import { TableDataTransform } from './table-data-transform';

/**
 * EstimatedCapitalGainsTransform is used for:
 * - setting daysLeft to null for non-active statuses - used for sorting in the table
 * - update display order for statuses based on config
 */
export class EstimatedCapitalGainsTransform implements TableDataTransform {

	@InjectConfig(TaxConfigKey.ESTIMATED_CAPITAL_GAIN_STATUSES_ORDER) private readonly capGainStatusOrder: Array<{ displayOrder: number; dcrKey: string }>;

	public transform(data: TableData, contentSvc?: ContentService): TableData {

		if (data && !isNil(data.cells)) {
			data.cells.forEach((cellArray, index) => {
				const status = CellUtil.getById(cellArray, 'capGainsStatus')['formattedValue'];

				// This is used for sorting the estimates table to show rows with values first and then show status rows
				if (!!status && CellUtil.getById(cellArray, 'daysLeft')) {
					CellUtil.getById(cellArray, 'daysLeft').rawValue = null;
				}

				if (!status) {
					// remove Active status
					const index = cellArray.findIndex(cell => cell.config.id === 'capGainsStatus');
					cellArray.splice(index, 1);

				} else {
					// Update display order for valid statuses to show
					this.insertDisplayOrder(cellArray, status);
				}

				data.cells[index] = cellArray;
			});
		}

		return data;
	}

	private insertDisplayOrder(cellArray: CellData[], status: string): void {
		const displayOrder = this.capGainStatusOrder?.find(elem => elem?.['dcrKey'] === status)?.displayOrder;
		const statusDisplayOrderCellData = CellData.create({
			rawValue: displayOrder,
			formattedValue: displayOrder as any,
			config: ColumnConfig.create({
				id: 'displayOrder',
				label: null,
				infoBubble: null,
				extractor: null,
				labelFormatter: null,
				formatters: null,
				visible: null
			}),
			attribute: {}
		});

		cellArray.push(statusDisplayOrderCellData);
	}
}
